import type { LibraryBlock } from "../build";
import { logo, motion, pill, rect, SHADOW, stack, text, WHITE } from "./helpers";

export const TITLES: LibraryBlock[] = [
  {
    id: "titel-pop",
    title: "Großer Titel",
    category: "titel",
    width: 980,
    height: 300,
    anchor: "top",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 20,
        w: 980,
        h: 260,
        fill: "accent",
        radius: "md",
        rotation: -2.5,
        name: "Fläche",
        ...motion("pop"),
      }),
      text({
        text: "Das musst du wissen",
        style: "heading-1",
        size: 104,
        color: "on:accent",
        x: 50,
        y: 20,
        w: 880,
        h: 260,
        align: "center",
        rotation: -2.5,
        ...motion("pop", { delay: 120 }),
      }),
    ],
  },
  {
    id: "titel-zwei-zeilen",
    title: "Zwei Zeilen",
    category: "titel",
    width: 960,
    height: 330,
    anchor: "center",
    duration: 3500,
    nodes: [
      stack({
        x: 0,
        y: 0,
        w: 960,
        align: "center",
        gap: 18,
        items: [
          {
            kind: "text",
            text: "SO GEHT'S",
            style: "subline",
            size: 46,
            color: "accent",
            shadow: SHADOW,
            ...motion("slide-down"),
          },
          {
            kind: "text",
            text: "In drei Minuten zum Profi",
            style: "heading-1",
            size: 108,
            color: WHITE,
            shadow: SHADOW,
            ...motion("slide-up", { delay: 160, duration: 600 }),
          },
        ],
      }),
    ],
  },
  {
    id: "titel-schreibmaschine",
    title: "Schreibmaschine",
    category: "titel",
    width: 940,
    height: 260,
    anchor: "center",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 940,
        h: 260,
        fill: "#000000b3",
        radius: "md",
        name: "Fläche",
        ...motion("fade"),
      }),
      text({
        text: "Was wäre, wenn\u00a0…?",
        style: "heading-1",
        size: 88,
        color: WHITE,
        x: 50,
        y: 0,
        w: 840,
        h: 260,
        align: "center",
        ...motion("typewriter", { delay: 200, duration: 1400 }),
      }),
    ],
  },
  {
    id: "titel-kapitel",
    title: "Kapitel-Nummer",
    category: "titel",
    width: 900,
    height: 420,
    anchor: "center",
    duration: 3500,
    nodes: [
      text({
        text: "01",
        style: "heading-1",
        size: 240,
        color: "accent",
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 900,
        align: "center",
        ...motion("fly-left", { duration: 700 }),
      }),
      {
        kind: "shape",
        shape: "line",
        x: 330,
        y: 282,
        w: 240,
        h: 18,
        stroke: { color: WHITE, width: 5 },
        name: "Linie",
        ...motion("zoom", { delay: 300 }),
      },
      text({
        text: "Die Idee",
        style: "heading-2",
        size: 72,
        color: WHITE,
        shadow: SHADOW,
        x: 0,
        y: 318,
        w: 900,
        align: "center",
        ...motion("slide-up", { delay: 400 }),
      }),
    ],
  },
  {
    id: "titel-reinfliegen",
    title: "Wörter fliegen rein",
    category: "titel",
    width: 960,
    height: 360,
    anchor: "center",
    duration: 3000,
    nodes: [
      text({
        text: "JETZT",
        style: "heading-1",
        size: 160,
        color: WHITE,
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 960,
        align: "center",
        ...motion("fly-right", { duration: 600, out: "fly-left" }),
      }),
      text({
        text: "NEU",
        style: "heading-1",
        size: 160,
        color: "accent",
        shadow: SHADOW,
        x: 0,
        y: 180,
        w: 960,
        align: "center",
        ...motion("fly-left", { delay: 200, duration: 600, out: "fly-right" }),
      }),
    ],
  },
  {
    id: "titel-banner",
    title: "Schräges Banner",
    category: "titel",
    width: 1080,
    height: 260,
    anchor: "center",
    duration: 3500,
    nodes: [
      rect({
        x: -60,
        y: 40,
        w: 1200,
        h: 180,
        fill: "primary",
        rotation: -5,
        name: "Banner",
        ...motion("fly-left", { duration: 550, out: "fly-right" }),
      }),
      text({
        text: "Großer Sommer-Sale",
        style: "heading-1",
        size: 92,
        color: "on:primary",
        x: 60,
        y: 40,
        w: 960,
        h: 180,
        align: "center",
        rotation: -5,
        ...motion("fly-left", { delay: 80, duration: 550, out: "fly-right" }),
      }),
    ],
  },
  {
    id: "titel-abspann",
    title: "Abspann mit Logo",
    category: "intro",
    tags: ["Outro", "Danke", "Ende", "Logo", "Folgen"],
    width: 900,
    height: 520,
    anchor: "center",
    duration: 4000,
    only: "video",
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 900,
        h: 520,
        fill: "background",
        radius: "lg",
        name: "Karte",
        ...motion("zoom"),
      }),
      logo({
        x: 250,
        y: 60,
        w: 400,
        h: 130,
        on: "background",
        align: "center",
        ...motion("fade", { delay: 250 }),
      }),
      text({
        text: "Danke fürs Zuschauen!",
        style: "heading-2",
        size: 64,
        color: "text",
        x: 60,
        y: 230,
        w: 780,
        align: "center",
        ...motion("slide-up", { delay: 400 }),
      }),
      ...pill(
        250,
        380,
        400,
        84,
        "Folge uns",
        "primary",
        36,
        motion("pop", { delay: 650, loop: "pulse" }),
      ),
    ],
  },
  {
    id: "titel-wort-fuer-wort",
    title: "Wort für Wort",
    category: "titel",
    tags: ["Hook", "Einstieg", "Wörter", "nacheinander"],
    width: 960,
    height: 540,
    anchor: "center",
    duration: 3500,
    nodes: [
      stack({
        x: 0,
        y: 270,
        w: 960,
        anchor: "center",
        align: "center",
        gap: 0,
        items: [
          {
            kind: "text",
            text: "Das",
            style: "heading-1",
            size: 150,
            color: WHITE,
            shadow: SHADOW,
            ...motion("pop", { duration: 400 }),
          },
          {
            kind: "text",
            text: "ändert",
            style: "heading-1",
            size: 150,
            color: WHITE,
            shadow: SHADOW,
            ...motion("pop", { delay: 350, duration: 400 }),
          },
          {
            kind: "text",
            text: "alles.",
            style: "heading-1",
            size: 150,
            color: "accent",
            shadow: SHADOW,
            ...motion("pop", { delay: 700, duration: 400 }),
          },
        ],
      }),
    ],
  },
  {
    id: "titel-markierung",
    title: "Mit Markierung",
    category: "titel",
    tags: ["Highlight", "Textmarker", "hervorheben"],
    width: 960,
    height: 320,
    anchor: "center",
    duration: 3500,
    nodes: [
      text({
        text: "Der beste Tipp",
        style: "heading-1",
        size: 100,
        color: WHITE,
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 960,
        align: "center",
        ...motion("slide-up"),
      }),
      rect({
        x: 190,
        y: 150,
        w: 580,
        h: 150,
        fill: "accent",
        radius: "sm",
        rotation: -2,
        name: "Markierung",
        ...motion("slide-right", { delay: 300, duration: 450 }),
      }),
      text({
        text: "für dich",
        style: "heading-1",
        size: 100,
        color: "on:accent",
        x: 210,
        y: 150,
        w: 540,
        h: 150,
        align: "center",
        rotation: -2,
        ...motion("pop", { delay: 420 }),
      }),
    ],
  },
  {
    id: "titel-karte",
    title: "Titel-Karte",
    category: "titel",
    tags: ["Folge", "Episode", "Überschrift"],
    width: 960,
    height: 400,
    anchor: "top",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 960,
        h: 400,
        fill: "background/95",
        radius: "lg",
        name: "Karte",
        ...motion("slide-down"),
      }),
      ...pill(50, 50, 240, 60, "FOLGE 12", "primary", 26, motion("pop", { delay: 150 })),
      text({
        text: "Unser Weg zur eigenen Marke",
        style: "heading-1",
        size: 68,
        color: "text",
        x: 50,
        y: 140,
        w: 860,
        ...motion("slide-up", { delay: 250 }),
      }),
      text({
        text: "Mit Gästen aus der Region",
        style: "subline",
        size: 32,
        color: "text-muted",
        x: 50,
        y: 318,
        w: 860,
        ...motion("fade", { delay: 450 }),
      }),
    ],
  },
  {
    id: "titel-rahmen",
    title: "Im Rahmen",
    category: "titel",
    tags: ["Kontur", "exklusiv", "Kasten"],
    width: 900,
    height: 300,
    anchor: "center",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 30,
        w: 900,
        h: 270,
        stroke: { color: "accent", width: 10 },
        name: "Rahmen",
        ...motion("zoom"),
      }),
      text({
        text: "Hinter den Kulissen",
        style: "heading-1",
        size: 84,
        color: WHITE,
        shadow: SHADOW,
        x: 50,
        y: 50,
        w: 800,
        h: 250,
        align: "center",
        ...motion("fade", { delay: 250 }),
      }),
      ...pill(320, 0, 260, 60, "EXKLUSIV", "accent", 26, motion("pop", { delay: 150 })),
    ],
  },
  {
    id: "titel-teil",
    title: "Teil 1 von 3",
    category: "titel",
    tags: ["Serie", "Fortschritt", "Reihe", "Episode"],
    width: 800,
    height: 290,
    anchor: "center",
    duration: 3500,
    nodes: [
      text({
        text: "TEIL 1",
        style: "heading-1",
        size: 130,
        color: WHITE,
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 800,
        align: "center",
        ...motion("pop"),
      }),
      rect({
        x: 150,
        y: 186,
        w: 500,
        h: 22,
        fill: "#ffffff4d",
        radius: "full",
        name: "Leiste",
        ...motion("fade", { delay: 200 }),
      }),
      rect({
        x: 150,
        y: 186,
        w: 167,
        h: 22,
        fill: "accent",
        radius: "full",
        name: "Fortschritt",
        ...motion("slide-right", { delay: 350, duration: 600 }),
      }),
      text({
        text: "von 3",
        style: "subline",
        size: 36,
        color: "#ffffffdd",
        shadow: SHADOW,
        x: 0,
        y: 228,
        w: 800,
        align: "center",
        ...motion("fade", { delay: 450 }),
      }),
    ],
  },
  {
    id: "titel-leuchtschrift",
    title: "Leuchtschrift",
    category: "titel",
    tags: ["Neon", "Glow", "leuchten", "Abend"],
    width: 960,
    height: 250,
    anchor: "center",
    duration: 3500,
    nodes: [
      text({
        text: "Heute Abend",
        style: "heading-1",
        size: 110,
        color: WHITE,
        shadow: { color: "accent", blur: 40, y: 0 },
        x: 0,
        y: 0,
        w: 960,
        align: "center",
        ...motion("blur", { duration: 700 }),
      }),
      text({
        text: "ab 20 Uhr",
        style: "subline",
        size: 46,
        color: "accent",
        shadow: { color: "accent", blur: 24, y: 0 },
        x: 0,
        y: 160,
        w: 960,
        align: "center",
        ...motion("blur", { delay: 350, duration: 600 }),
      }),
    ],
  },
  {
    id: "titel-zweifarbig",
    title: "Zweifarbig",
    category: "titel",
    tags: ["zwei Zeilen", "Kontrast", "Statement"],
    width: 900,
    height: 340,
    anchor: "center",
    duration: 3500,
    nodes: [
      rect({ x: 0, y: 10, w: 16, h: 320, fill: "accent", name: "Akzent", ...motion("slide-down") }),
      text({
        text: "WENIGER",
        style: "heading-1",
        size: 140,
        color: WHITE,
        shadow: SHADOW,
        x: 50,
        y: 0,
        w: 850,
        ...motion("fly-right", { duration: 600 }),
      }),
      text({
        text: "IST MEHR",
        style: "heading-1",
        size: 140,
        color: "accent",
        shadow: SHADOW,
        x: 50,
        y: 170,
        w: 850,
        ...motion("fly-right", { delay: 200, duration: 600 }),
      }),
    ],
  },
];
